import React, { useEffect, useState } from 'react';

import IconAlert from './IconAlert';
import ButtonNexcareDefault from '../Button/ButtonNexcareDefault';
import ButtonBorderNexcareDefault from '../Button/ButtonBorderNexcareDefault';

function Alert({ show, button, icon, title, desc, close, ok, submit, buttonOKText, buttonCancelText, maxContentButtons = false, buttonOKType = 'fill', buttonCancelType = 'outline' }) {
    const defaultClass = 'opacity-0 transform scale-125'
    const showClass = 'opacity-1 transform scale-100'

    const [classShow, setClassShow] = useState(defaultClass)

    // const getButtonClass = (type) => {
    //     if (type === 'outline') {
    //         return 'bg-white text-darkblue border border-darkblue'
    //     }

    //     return 'bg-lightblue text-white border border-lightblue'
    // }

    useEffect(() => {
        if (show) {
            setClassShow(showClass)
        } else {
            setClassShow(defaultClass)
        }
    }, [show])

    useEffect(() => {
        const cb = e => {
            if (e.which === 27) {
                if (close !== undefined) close()
            }
        }
        window.addEventListener('keydown', cb)
        return () => window.removeEventListener('keydown', cb)
    }, [close])

    if (!show) return null
    return (
        <div>
            <div className={"transition duration-300 flex justify-center items-center fixed inset-0 outline-none focus:outline-none " + classShow} style={{ zIndex: 100 }}>
                <div className="border-0 rounded-2xl shadow bg-white outline-none focus:outline-none p-10 text-center text-gray-600 alert-box">
                    {
                        icon && (
                            <div className="flex justify-center mb-3">
                                <IconAlert icon={icon} />
                            </div>
                        )
                    }
                    <div className="text-2xl font-medium whitespace-normal mb-3">
                        {title}
                    </div>
                    <div className="text-lg whitespace-normal mb-3">
                        {desc}
                    </div>
                    <div className={button ? "block space-x-5" : "hidden"}>
                        {/* <button type="button" id="btnno" className={`rounded focus:outline-none py-2 mr-3 ${getButtonClass(buttonCancelType)} ${maxContentButtons ? 'px-6' : 'w-28'}`} onClick={close}>{buttonCancelText || 'Tidak'}</button>
                        <button type="button" id="btnyes" className={`rounded focus:outline-none py-2 ml-3 ${getButtonClass(buttonOKType)} ${maxContentButtons ? 'px-6' : 'w-28'}`} onClick={submit}>{buttonOKText || 'Ya'}</button> */}
                        <ButtonBorderNexcareDefault type="button" id="btnno" className={!maxContentButtons && "w-28"} onClick={close}>
                            {buttonCancelText || 'Tidak'}
                        </ButtonBorderNexcareDefault>
                        <ButtonNexcareDefault type="button" id="btnyes" className={!maxContentButtons && "w-28"} onClick={submit}>
                            {buttonOKText || 'Ya'}
                        </ButtonNexcareDefault>
                    </div>
                    <div className={ok ? "block" : "hidden"}>
                        {/* <button type="button" id="btnok" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none w-28 py-2" onClick={close} autoFocus>OK</button> */}
                        <ButtonNexcareDefault type="button" id="btnok" className={!maxContentButtons && "w-28"} onClick={close} autoFocus>
                            OK
                        </ButtonNexcareDefault>
                    </div>
                </div>
            </div>
            <div className="opacity-25 fixed inset-0 bg-black" style={{ zIndex: 99 }}></div>
        </div>
    )
}

export default Alert;
